/* eslint-disable */
export default {
  from: '自',
  to: '至',
  enterNameOrNumber: '输入号码或姓名…',
  typeMessage: '输入消息…',
  send: '发送',
  emoji: '表情符号',
} as const;

// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number or Name..."@#@
// @key: @#@"typeMessage"@#@ @source: @#@"Type message..."@#@
// @key: @#@"send"@#@ @source: @#@"Send"@#@
// @key: @#@"emoji"@#@ @source: @#@"Emoji"@#@
